/**
 * The name of the application
 *
 * Shown for example in the {@link TmrPageTitle page title}.
 * Brandings should override this.
 *
 * @namespace tmrAppName
 * @type {ngConstant}
 */
export const constant = ['tmrAppName', 'Stylewhere']
